import axios from 'axios'
import * as utils from './apiUtils'

export default {
  login(data) {
    return axios.post(utils.getApiUrl('/users/login'), {
      user: data
    })
  },
  logout() {
    return axios.delete(utils.getApiUrl('/users/logout'))
  },
  getMe() {
    return axios.get(utils.getApiUrl('/users/me'))
  },
}
